"use strict";
// (C) 2019-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluggableXirr = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var sdk_ui_charts_1 = require("@gooddata/sdk-ui-charts");
var react_1 = tslib_1.__importDefault(require("react"));
var react_dom_1 = require("react-dom");
var bucketHelper_1 = require("../../../utils/bucketHelper");
var bucketRules_1 = require("../../../utils/bucketRules");
var domHelper_1 = require("../../../utils/domHelper");
var propertiesHelper_1 = require("../../../utils/propertiesHelper");
var sort_1 = require("../../../utils/sort");
var xirrUiConfigHelper_1 = require("../../../utils/uiConfigHelpers/xirrUiConfigHelper");
var UnsupportedConfigurationPanel_1 = tslib_1.__importDefault(require("../../configurationPanels/UnsupportedConfigurationPanel"));
var AbstractPluggableVisualization_1 = require("../AbstractPluggableVisualization");
var xirrBucketHelper_1 = require("./xirrBucketHelper");
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var PluggableXirr = /** @class */ (function (_super) {
    tslib_1.__extends(PluggableXirr, _super);
    function PluggableXirr(props) {
        var _this = _super.call(this, props) || this;
        _this.getExtendedReferencePoint = function (referencePoint) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var referencePointCloned, newReferencePoint, buckets;
            return tslib_1.__generator(this, function (_a) {
                referencePointCloned = cloneDeep_1.default(referencePoint);
                newReferencePoint = tslib_1.__assign(tslib_1.__assign({}, referencePointCloned), { uiConfig: xirrUiConfigHelper_1.getDefaultXirrUiConfig() });
                if (!bucketRules_1.hasGlobalDateFilter(referencePoint.filters)) {
                    newReferencePoint = bucketHelper_1.removeAllArithmeticMeasuresFromDerived(newReferencePoint);
                    newReferencePoint = bucketHelper_1.removeAllDerivedMeasures(newReferencePoint);
                }
                buckets = xirrBucketHelper_1.getXirrBuckets(referencePoint);
                newReferencePoint.buckets = buckets;
                newReferencePoint.uiConfig = xirrUiConfigHelper_1.getXirrUiConfig(newReferencePoint, this.intl);
                newReferencePoint = sort_1.removeSort(newReferencePoint);
                newReferencePoint = propertiesHelper_1.getReferencePointWithSupportedProperties(newReferencePoint, this.supportedPropertiesList);
                return [2 /*return*/, bucketHelper_1.sanitizeFilters(newReferencePoint)];
            });
        }); };
        // This is effectively calling super.pushData()
        // https://stackoverflow.com/questions/31088947/inheritance-method-call-triggers-typescript-compiler-error
        // https://github.com/basarat/typescript-book/blob/master/docs/arrow-functions.md#tip-arrow-functions-and-inheritance
        _this.superPushData = _this.pushData;
        _this.pushData = function (data, options) {
            // For xirr chart we do not support drilling from attributes.
            var filterAtrributes = _this.withEmptyAttributeTargets(data);
            _this.superPushData(filterAtrributes, options);
        };
        _this.settings = props.featureFlags;
        _this.renderFun = props.renderFun;
        return _this;
    }
    PluggableXirr.prototype.unmount = function () {
        domHelper_1.unmountComponentsAtNodes([this.element, this.configPanelElement]);
    };
    PluggableXirr.prototype.getExecution = function (options, insight, executionFactory) {
        var _a;
        var dateFormat = options.dateFormat;
        return (_a = executionFactory
            .forInsight(insight))
            .withDimensions.apply(_a, this.getXirrDimensions(insight)).withDateFormat(dateFormat);
    };
    PluggableXirr.prototype.renderVisualization = function (options, insight, executionFactory) {
        var locale = options.locale, _a = options.custom, custom = _a === void 0 ? {} : _a, config = options.config;
        var drillableItems = custom.drillableItems;
        var execution = this.getExecution(options, insight, executionFactory);
        this.renderFun(react_1.default.createElement(sdk_ui_charts_1.CoreXirr, { execution: execution, drillableItems: drillableItems, onDrill: this.onDrill, locale: locale, config: sdk_ui_charts_1.updateConfigWithSettings(config, this.settings), afterRender: this.afterRender, onLoadingChanged: this.onLoadingChanged, pushData: this.pushData, onError: this.onError, LoadingComponent: null, ErrorComponent: null }), document.querySelector(this.element));
    };
    PluggableXirr.prototype.renderConfigurationPanel = function () {
        var _a;
        if (document.querySelector(this.configPanelElement)) {
            var properties = (_a = this.visualizationProperties) !== null && _a !== void 0 ? _a : {};
            react_dom_1.render(react_1.default.createElement(UnsupportedConfigurationPanel_1.default, { locale: this.locale, pushData: this.pushData, properties: propertiesHelper_1.getSupportedProperties(properties, this.supportedPropertiesList) }), document.querySelector(this.configPanelElement));
        }
    };
    PluggableXirr.prototype.getXirrDimensions = function (insight) {
        var attribute = sdk_model_1.insightBucket(insight, sdk_ui_1.BucketNames.ATTRIBUTE);
        if (attribute && attribute.items.length) {
            return [
                sdk_model_1.newDimension(tslib_1.__spreadArrays([sdk_model_1.MeasureGroupIdentifier], sdk_model_1.bucketAttributes(attribute).map(sdk_model_1.attributeLocalId))),
            ];
        }
        return [sdk_model_1.newDimension([sdk_model_1.MeasureGroupIdentifier])];
    };
    PluggableXirr.prototype.withEmptyAttributeTargets = function (data) {
        return tslib_1.__assign(tslib_1.__assign({}, data), { availableDrillTargets: tslib_1.__assign(tslib_1.__assign({}, data === null || data === void 0 ? void 0 : data.availableDrillTargets), { attributes: [] }) });
    };
    return PluggableXirr;
}(AbstractPluggableVisualization_1.AbstractPluggableVisualization));
exports.PluggableXirr = PluggableXirr;
//# sourceMappingURL=PluggableXirr.js.map